export { viewTopicRoute } from './routes';
